export default "__VITE_ASSET__BIw2eDJ0__"